/*
 *   Copyright (c) 2020 BuserNet Consulting LLC
 *   All rights reserved.
 */

import _forEach from 'lodash/forEach';
import AppConst from '../../constants/app.constant';
import utilityService from '../../services/utility.service';
import bnChartDataService from '../../services/chartData.service';
import dashboardDataSource from './Airport.data';
import { getMetarTabData } from './tabs/getMetarTabData';
import { getTafsTabData } from './tabs/getTafsTabData';
import { getFcstDiscussion } from './tabs/getFcstDiscussion';

function airportService() {
  const content = {};

  function getAloftFromCache() {
    // Need to implement axios caching
    // var aloftCache = CacheFactory.get(AppConst.apiCaches.gribCache);
    // var aloftCacheData;
    // if (aloftCache) {
    //     aloftCacheData = aloftCache.get(
    // httpService.getAloftProjection(data.lamp.lat, data.lamp.lng));
    // }
    // if (aloftCacheData && aloftCacheData[1]) {
    //     return true;
    // } else {
    //     return false;
    // }
    return false;
  }

  function get12HoursRecords(fullData) {
    fullData.twelvehours = utilityService.clone(fullData.lamp);
    if (fullData.twelvehours.forecast) {
      fullData.twelvehours.forecast = fullData.twelvehours.forecast.slice(0, 12);
    }
  }
  content.getMeteogramData = async (settings, airportsListing) => {
    if (!settings.isForMos) {
      dashboardDataSource.cleanFactory();
    }
    settings.airportDetails = utilityService.getMatchedAirportObject(
      settings.start,
      airportsListing,
    );
    if (settings.airportDetails) {
      let fullData = await bnChartDataService.getAllRequiredData(
        settings,
        AppConst.dataMode.meteogram,
      );
      if (fullData) {
        if (!settings.isForMos) {
          fullData.airportTabs = settings.airportDetails.tabs;
          fullData.aloftCacheDataAvailable = getAloftFromCache(fullData);
          get12HoursRecords(fullData);
          fullData.tabCacheAvaialble = true;
        }
        return fullData;
      }
      fullData = {};
      if (!settings.isForMos) {
        fullData.airportTabs = settings.airportDetails.tabs;
        fullData.tabCacheAvaialble = true;
        fullData.noDataAvailable = true;
      }
      return fullData;
    }
    const fullData = {};
    fullData.airportTabs = [{
      text: 'Meteogram',
      key: 'meteogram',
      param: 0,
    }];
    fullData.tabCacheAvaialble = true;
    fullData.noDataAvailable = true;
    return fullData;
  };

  content.getMeteogramAloftData = async (lat, lng, airport, settings) => bnChartDataService
    .getAloftData(
      lat,
      lng,
      null,
      AppConst.dataMode.meteogram,
      airport,
      0,
      settings.maximumAltitudeAllowed,
    );

  content.getParamIndexForAction = (action, tabs, getIndex) => {
    let idx = 0;
    _forEach(tabs, (value, key) => {
      if (value.key === action) {
        if (getIndex) {
          idx = key;
        } else {
          idx = value.param;
        }
      }
    });
    return idx;
  };

  const getTabData = async (actionKey, icao_id, nws) => {
    switch (actionKey) {
      case 'metars':
        return getMetarTabData(icao_id);
      case 'tafs':
        return getTafsTabData(icao_id);
      case 'fcstdiscussion':
        return getFcstDiscussion(nws, icao_id);
      default:
    }
  };
  content.getAirportTabData = async (icao_id, actionKey, isMobileView, tabs, airportDetails) => {
    const actionIdx = content.getParamIndexForAction(actionKey, tabs, false);
    if (actionKey === 'meteogram') {
      // If action is meteogram then no need to fetch meteogram data
      return {
        actionKey,
        actionData: '',
      };
    }
    if (actionIdx !== null) {
      if (!airportDetails) {
        airportDetails = utilityService.getMatchedAirportObject(icao_id);
      }
      const airportTabData = await getTabData(actionKey, icao_id, airportDetails.nws);
      if (airportTabData && airportTabData.errorMessage) {
        return {
          actionKey,
          actionData: {
            error: `<div class='airport-tab-content no-data-service'>${airportTabData.errorMessage}</div>`,
          },
        };
      }
      const responseData = {
        actionKey,
        actionData: airportTabData,
      };
      return responseData;
    }
    const responseData = {
      actionKey,
      actionData: null,
    };
    return responseData;
  };
  return content;
}

export default airportService();
